import { jsx } from "react/jsx-runtime";
import { useMemo, useEffect, createElement } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { Person } from "@mui/icons-material";
import { Autocomplete } from "@mui/material";
import "lottie-react";
import "../../../../../themes/shadows/shadows.js";
import "../../../../../themes/typography/typography.js";
import "../../../../../components/avatar-group/avatar-group.styles.js";
import "../../../../../components/date-pickers/pickers-action-bar/pickers-action-bar.js";
import "../../../../../components/date-pickers/date-picker/theme/index.js";
import "../../../../../components/dialog/dialog.js";
import "../../../../../components/icons/all/all.js";
import "../../../../../components/label/label.styles.js";
import { MenuItem } from "../../../../../components/menu-item/menu-item.js";
import "../../../../../components/slider/slider.styles.js";
import "@mui/material/styles";
import "../../../../../components/snackbar/snackbar.styles.js";
import "../../../../../components/styled-text-field/styled-text-field.styles.js";
import "../../../../../components/swipeable-drawer/swipeable-drawer.js";
import "../../../../../components/translations/utils.js";
import "../../../../../components/time-select/time-select.styles.js";
import "../../../../../components/time-interval-select/time-interval-select.styles.js";
import { EmployeeIcon } from "../../assets/icons/Employee.js";
import { insertIf } from "../../helpers/common.js";
import { useEmployeeSearch } from "../../hooks/useEmployeeSearch.js";
import { LABEL_OFFSET } from "../appointment-form/appointment-form.constants.js";
import { initialEmployeeRoles } from "../appointment-form/appointment-form.helpers.js";
import { EmployeeAutocompleteSkeleton } from "./employee-autocomplete.skeleton.js";
import { AutocompleteTextField } from "./employee-autocomplete.styles.js";
import "../../../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "@mui/system";
import "@mui/material/Button/index.js";
import "@mui/x-date-pickers/internals/index.js";
import "../../../../../constants/create-theme/create-theme.js";
import "../../../../../constants/colors/palette.js";
import "../../../../../themes/button/button.js";
import "../../../../../themes/button/styles/external/bordered.styles.js";
import "color-alpha";
import "../../../../../themes/button/styles/external/filled.styles.js";
import "../../../../../themes/button/styles/internal/bordered.styles.js";
import "../../../../../themes/button/styles/internal/borderless.styles.js";
import "../../../../../themes/button/styles/internal/filled.styles.js";
import "../../../../../themes/button/styles/internal/shadowed.styles.js";
import "../../../../../components/date-pickers/pickers-action-bar/pickers-action-bar.styles.js";
import "../../../../../themes/date-calendar/date-calendar.js";
import "../../../../../themes/date-picker-toolbar/date-picker-toolbar.js";
import "../../../../../themes/day-calendar/day-calendar.js";
import "../../../../../themes/filled-input/filled-input.js";
import "../../../../../themes/form-helper-text/form-helper-text.js";
import "../../../../../themes/form-label/form-label.js";
import "../../../../../themes/month-calendar/month-calendar.js";
import "../../../../../themes/pickers-arrow-switcher/pickers-arrow-switcher.js";
import "../../../../../themes/pickers-calendar-header/pickers-calendar-header.js";
import "../../../../../themes/pickers-day/pickers-day.js";
import "@mui/x-date-pickers";
import "../../../../../themes/pickers-month/pickers-month.js";
import "../../../../../themes/pickers-popper/pickers-popper.js";
import "../../../../../themes/pickers-toolbar/pickers-toolbar.js";
import "../../../../../themes/pickers-year/pickers-year.js";
import "../../../../../themes/year-calendar/year-calendar.js";
import "@mui/icons-material/Close.js";
import "../../../../../themes/alert/alert.js";
import "../../../../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../../../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../../../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../../../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../../../../themes/dialog/dialog.js";
import "../../../../../themes/external-theme/external-theme.js";
import "../../../../../constants/breakpoints/breakpoints.js";
import "../../../../../themes/checkbox/checkbox.js";
import "../../../../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../../../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../../../../themes/form-control-label/form-control-label.js";
import "../../../../../themes/radio/radio.js";
import "../../../../../themes/switch/switch.js";
import "../../../../../themes/popover/popover.js";
import "../../../../../themes/tooltip/tooltip.js";
import "../../../../../components/dialog/dialog.constants.js";
import "../../../../../components/dialog/dialog.styles.js";
import "@emotion/react";
import "../../../../../components/dialog/DraggablePaperComponent.js";
import "react-draggable";
import "../../../../../components/icons/CalendarEventIcon/CalendarEventIcon.js";
import "../../../../../components/icons/MainIcon/MainIcon.js";
import "../../../../../components/icons/CalendarIcon/CalendarIcon.js";
import "../../../../../components/icons/CardIcon/CardIcon.js";
import "../../../../../components/icons/ChecklistIcon/ChecklistIcon.js";
import "../../../../../components/icons/ClockIcon/ClockIcon.js";
import "../../../../../components/icons/CloseIcon/CloseIcon.js";
import "../../../../../components/icons/EditIcon/EditIcon.js";
import "../../../../../components/icons/EmptyCalendar/EmptyCalendar.js";
import "../../../../../components/icons/EventNote/EventNote.js";
import "../../../../../components/icons/FilterIcon/FilterIcon.js";
import "../../../../../components/icons/ListIcon/ListIcon.js";
import "../../../../../components/icons/MessageBubble/MessageBubble.js";
import "../../../../../components/icons/PhoneIcon/PhoneIcon.js";
import "../../../../../components/icons/PinIcon/PinIcon.js";
import "../../../../../components/icons/SearchIcon/SearchIcon.js";
import "../../../../../components/icons/TherapyNotesIcon/TherapyNotesIcon.js";
import "../../../../../components/icons/TimerIcon/TimerIcon.js";
import "../../../../../components/icons/TreatmentChairIcon/TreatmentIcon.js";
import "../../../../../components/icons/VisibilityOffIcon/VisibilityOffIcon.js";
import "../../../../../components/icons/WarningIcon/WarningIcon.js";
import "@mui/material/MenuItem/index.js";
import "../../../../../components/menu-item/components/menu-item-counter/menu-item-counter.js";
import "../../../../../components/menu-item/assets/icons/minus-circle.js";
import "../../../../../components/menu-item/assets/icons/plus-circle.js";
import "../../../../../components/menu-item/components/menu-item-counter/menu-item-counter.styles.js";
import "../../../../../components/menu-item/menu-item.styles.js";
import "../../../../../components/avatar/avatar.js";
import "@mui/material/Avatar/index.js";
import "../../../../../components/avatar/avatar.styles.js";
import "@mui/material/Snackbar/index.js";
import "../../../../../components/snackbar/snackbar.types.js";
import "../../../../../components/text-field/text-field.js";
import "@mui/material/TextField/index.js";
import "../../../../../components/text-field/text-field.styles.js";
import "../../../../../components/swipeable-drawer/swipeable-drawer.styles.js";
import "react-i18next";
import "../../../../../type/Translations.js";
import "contentful";
import "i18next";
import "lodash/set.js";
import "remarkable";
import "remarkable-react";
import "@mui/icons-material/Timer.js";
import "@mui/material/FormControl/index.js";
import "@mui/material/InputLabel/index.js";
import "@mui/material/Select/index.js";
import "@mui/material/Box/index.js";
import "date-fns";
import "date-fns/locale";
import "../../appointment-details.types.js";
import "@tanstack/react-query";
import "../../providers/axios-provider.js";
import "axios";
import "../../../../../constants/date/date.js";
import "../../helpers/appointment.js";
const EmployeeAutocomplete = ({
  clinicReferenceId,
  labels,
  employees: initialEmployees,
  canUseRandomEmployee = false,
  isNewAppointment = false,
  isTreatmentBundle = false,
  isBlockerForm = false
}) => {
  const { control, watch, setValue } = useFormContext();
  const treatmentReferenceId = watch("treatmentReferenceId");
  const employeeReferenceId = watch("employeeReferenceId");
  const {
    data: employees = [],
    queryResult: { isFetching }
  } = useEmployeeSearch({
    treatmentReferenceId,
    clinicReferenceId
  });
  const options = useMemo(() => {
    const data = treatmentReferenceId ? employees : initialEmployees;
    const employeesOptions = data.map((employee) => ({
      label: employee.userName ?? employee.displayName,
      value: employee
    }));
    return [...insertIf(canUseRandomEmployee, { label: labels.noPreferredEmployee, value: null }), ...employeesOptions];
  }, [employees, treatmentReferenceId, canUseRandomEmployee, isTreatmentBundle]);
  const handleEmployeeChange = (onChange) => (_, option) => {
    var _a;
    onChange(((_a = option == null ? void 0 : option.value) == null ? void 0 : _a.referenceId) ?? null);
    if (isNewAppointment)
      setValue("startTime", null, { shouldValidate: true, shouldDirty: true, shouldTouch: true });
    if (canUseRandomEmployee) {
      if ((option == null ? void 0 : option.value) !== null)
        setValue("randomPractitioner", null, { shouldValidate: true });
    }
  };
  useEffect(() => {
    if (employees.length && !isFetching) {
      const usedEmployee = employees.find(({ referenceId }) => employeeReferenceId === referenceId);
      if (!usedEmployee && !!employees.length && !isNewAppointment) {
        setValue("employeeReferenceId", employees[0].referenceId, {
          shouldDirty: true,
          shouldValidate: true,
          shouldTouch: true
        });
      }
    }
  }, [employees, isFetching]);
  useEffect(() => {
    if (treatmentReferenceId) {
      setValue("employeeByRole", initialEmployeeRoles, {
        shouldDirty: true,
        shouldTouch: true,
        shouldValidate: true
      });
    }
  }, [treatmentReferenceId]);
  if (isFetching)
    return /* @__PURE__ */ jsx(EmployeeAutocompleteSkeleton, {});
  return /* @__PURE__ */ jsx(
    Controller,
    {
      name: "employeeReferenceId",
      control,
      render: ({ field: { value, onChange, ...rest }, fieldState: { isTouched, error } }) => {
        const autocompleteValue = options.find(
          ({ value: optionValue }) => (optionValue == null ? void 0 : optionValue.referenceId) === employeeReferenceId
        ) ?? {
          label: labels.noPreferredEmployee,
          value: null
        };
        const showError = !!error && isTouched;
        const disabled = !treatmentReferenceId && !isBlockerForm;
        return /* @__PURE__ */ jsx(
          Autocomplete,
          {
            ...rest,
            options,
            onChange: handleEmployeeChange(onChange),
            value: autocompleteValue,
            defaultValue: autocompleteValue,
            disableClearable: true,
            disabled,
            renderOption: (props, option) => {
              var _a, _b, _c;
              return /* @__PURE__ */ createElement(
                MenuItem,
                {
                  ...props,
                  selected: ((_a = option.value) == null ? void 0 : _a.referenceId) === value,
                  avatar: {
                    userName: option.label ?? "",
                    imageUrl: ((_b = option.value) == null ? void 0 : _b.imageUrl) ?? "",
                    ...!option.value && {
                      Icon: /* @__PURE__ */ jsx(Person, {})
                    }
                  },
                  key: (_c = option.value) == null ? void 0 : _c.referenceId
                },
                option.label
              );
            },
            renderInput: ({ InputLabelProps, InputProps, ...params }) => /* @__PURE__ */ jsx(
              AutocompleteTextField,
              {
                ...params,
                label: labels.label,
                labelOffset: LABEL_OFFSET,
                disabled,
                error: showError,
                helperText: showError && labels.error,
                required: true,
                InputProps: {
                  ...InputProps,
                  startAdornment: /* @__PURE__ */ jsx(EmployeeIcon, {})
                },
                InputLabelProps: {
                  ...InputLabelProps,
                  shrink: true
                }
              }
            )
          }
        );
      }
    }
  );
};
export {
  EmployeeAutocomplete
};
